const fujiBuildSearchQuery = (value) => {
  const fields = ['title', 'product_type', 'variants.title', 'tag', 'body', 'variants.sku', 'variants.barcode', 'vendor'];
  return value.trim().split(/\s+/u).filter(Boolean).map(word => {
    const escaped = word.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    return `(${fields.map(field => `${field}:"${escaped}"`).join(' OR ')})`;
  }).join(' AND ');
};

const fujiReadSearchQuery = (value) => {
  if (!value.startsWith('(title:"')) return null;
  const words = [];
  for (const group of value.split(') AND (')) {
    const match = group.match(/^\(?title:"((?:\\.|[^"\\])*)" OR product_type:/);
    if (!match) return null;
    try { words.push(JSON.parse(`"${match[1]}"`)); } catch { return null; }
  }
  const readable = words.join(' ');
  return fujiBuildSearchQuery(readable) === value ? readable : null;
};

const fujiSearchQuery = (value) => fujiBuildSearchQuery(fujiReadSearchQuery(value) ?? value);

class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    this.changeVersion = 0;

    if (this.input) {
      if (!this.input.form.dataset.fujiSearchEnhanced) {
        this.input.form.dataset.fujiSearchEnhanced = 'true';
        this.input.form.addEventListener('formdata', event => {
          const query = fujiSearchQuery(this.input.value);
          if (!query) return;
          event.formData.set('q', query);
          event.formData.set('options[prefix]', 'none');
          event.formData.set('options[unavailable_products]', 'show');
          event.formData.delete('fuji_search');
          event.formData.delete('page');
        });
      }
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      const onInput = debounce((event, version) => {
        if (version === this.changeVersion && !event.isComposing) this.onChange(event);
      }, 300);
      this.input.addEventListener('input', event => {
        this.toggleResetButton();
        onInput(event, ++this.changeVersion);
      });
    }
  }

  cancelPendingChange() {
    this.changeVersion += 1;
  }

  disconnectedCallback() {
    this.cancelPendingChange();
  }

  toggleResetButton() {
    if (!this.resetButton) return;
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return true;
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.cancelPendingChange();
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);


const fujiSearchPage = document.querySelector('[data-fuji-search-exact-query]');
if (fujiSearchPage) {
  const params = new URLSearchParams(window.location.search);
  const rawQuery = params.get('q') || '';
  const readableQuery = fujiReadSearchQuery(rawQuery);
  const exactQuery = readableQuery === null ? fujiBuildSearchQuery(rawQuery) : rawQuery;
  if (readableQuery !== null) {
    for (const input of document.querySelectorAll('input[type="search"][name="q"]')) input.value = readableQuery;
  }
  if (params.get('fuji_search') === 'broader') {
    for (const link of fujiSearchPage.querySelectorAll('a[href]')) {
      const target = new URL(link.href, window.location.origin);
      if (target.origin === window.location.origin && target.pathname === window.location.pathname && target.searchParams.get('q') === params.get('q')) {
        target.searchParams.set('fuji_search', 'broader');
        link.href = target.toString();
      }
    }
  }
  if (exactQuery && readableQuery === null && params.get('fuji_search') !== 'broader' && rawQuery !== exactQuery) {
    params.set('q', exactQuery);
    params.set('options[prefix]', 'none');
    params.set('options[unavailable_products]', 'show');
    params.delete('page');
    window.location.replace(`${window.location.pathname}?${params.toString()}`);
  }
}
